<template>
  <div class="page-today-performance">
    <div class="search-form">
      <el-form
        :model="searchData"
        inline
        ref="searchForm"
      >
        <el-form-item
          label="产品类型"
          prop="prdType"
        >
          <el-select
            v-model="searchData.prdType"
            clearable
          >
            <el-option
              v-for="item in dictList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上架时间"
          style="margin-right: 13px;"
          prop="startTime"
        >
          <el-date-picker
            v-model="searchData.startTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            :picker-options="$_yh_before(searchData.endTime)"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="至"
          prop="endTime"
        >
          <el-date-picker
            v-model="searchData.endTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            :picker-options="$_yh_after(searchData.startTime)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <section class='flex-between'>
      <div>
        <el-button
          type="primary"
          size="small"
          @click='onSearchClick'
        >查询</el-button>
        <el-button
          size="small"
          @click='onResetClick'
        >清空查询条件</el-button>
      </div>
    </section>
    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">{{emptyText}}</template>
      <el-table-column
        v-for="col in tableLabel"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :min-width="col.width"
      ></el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="onDetailClick(scope.row)"
            >产品详情</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>
<script>
import { getPagingData, addNav } from '@/mixins';
import mixin from '../mixin';

export default {
  name: 'LatestProduct',
  mixins: [getPagingData, mixin, addNav],
  data() {
    return {
      emptyText: this.$LS.empty,
      tableLabel: [{
        label: '产品代码',
        prop: 'prdCode',
        width: 100,
      }, {
        label: '产品名称',
        prop: 'prdName',
        width: 300,
      }, {
        label: '产品类型',
        prop: 'prdTypeRes',
        width: 100,
      }, {
        label: '产品状态',
        prop: 'saleStatusRes',
        width: 100,
      }, {
        label: '是否置顶',
        prop: 'isTopRes',
        width: 100,
      }, {
        label: '上架时间',
        prop: 'createTime',
        width: 200,
      }],
      currentPage: 1,
      sumCount: 0,
      tableData: [],
      dictList: [],
      searchData: {
        startTime: '',
        endTime: '',
        prdType: '',
      },
      searchParam: {
        startTime: '',
        endTime: '',
        prdType: '',
      },
    };
  },

  computed: {
    searchForm() {
      return this.$refs.searchForm;
    },
  },

  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },

  activated() {
    this.getTableData();
  },
  methods: {
    onResetClick() {
      this.searchForm.resetFields();
    },
    onSearchClick() {
      // 后端接收起止时间开闭
      const { startTime, endTime } = this.searchData;
      this.searchParam = {
        ...this.searchData,
        startTime: startTime ? `${startTime} 00:00:00` : '',
        endTime: endTime ? `${endTime} 23:59:59` : '',
      };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    getTableData() {
      this.getPagingData(this.$API.listLatestProduct);
    },
    onDetailClick(detail) {
      const routeMap = {
        1: '/financiaPrdDetail',
        2: '/cds-detail',
      };
      this.addNav({
        path: routeMap[detail.prdType],
        query: {
          prdCode: detail.prdCode,
        },
        name: '产品详情',
      });
    },
  },
};
</script>
